import { render, staticRenderFns } from "./UpcomingTag.vue?vue&type=template&id=7ff07ac6&scoped=true&"
var script = {}
import style0 from "./UpcomingTag.vue?vue&type=style&index=0&id=7ff07ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff07ac6",
  null
  
)

export default component.exports